import { ReactNode } from 'react';

import { Text } from '@atlaskit/primitives';

interface TestExecutedDateProps {
  children: ReactNode;
}

export const TestExecutedDate = ({ children }: TestExecutedDateProps) => {
  return (
    <Text size="medium" weight="regular" color="color.text">
      {children}
    </Text>
  );
};
